import React, { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Divider,
} from "@mui/material";
import { Tablecell } from "../../../../component/Methods";

const SummarySectionTwo = ({ strategies, strategyVal, modifiedSignalsData }) => {
  const [CombinedArray, setCombinedArray] = useState([]);

  useEffect(() => {
    // Only show data when we have modified signals data
    if (modifiedSignalsData && modifiedSignalsData.length > 0) {
      const count = modifiedSignalsData.length;
      const sumOfValues = modifiedSignalsData.reduce(
        (sum, item) => sum + parseFloat(item.value || 0),
        0
      );

      const positiveValuesSum = modifiedSignalsData.reduce(
        (sum, item) => {
          const value = parseFloat(item.value || 0);
          return value > 0 ? sum + value : sum;
        },
        0
      );

      const negativeValuesSum = modifiedSignalsData.reduce(
        (sum, item) => {
          const value = parseFloat(item.value || 0);
          return value < 0 ? sum + value : sum;
        },
        0
      );

      function roundit(number) {
        return number.toFixed(2).replace(/\.?0+$/, "");
      }

      const transformedArray = [
        { name: "Number of Signals in list", value: count },
        { name: "Long", value: roundit(positiveValuesSum) },
        { name: "Short", value: roundit(negativeValuesSum) },
        {
          name: "Gross Sum of Weights",
          value: roundit(positiveValuesSum - negativeValuesSum),
        },
        {
          name: "Net Sum of Weights",
          value: roundit(sumOfValues),
        },
      ];

      setCombinedArray(transformedArray);
    } else {
      // No modified signals data, show empty array
      setCombinedArray([]);
    }
  }, [modifiedSignalsData]);

  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          border: `100px ${theme.palette.lightGrey.tableHeader}`,
          borderRadius: "4px",
          marginTop: "10px",
          width: "80%",
          marginRight: 1,
        }}
      >

        <Table
          size="small"
          stickyHeader
          aria-label="a dense table"
          sx={{
            borderCollapse: "collapse",
            border: `1px solid ${theme.palette.divider}`,
            marginTop: "0px",
          }}
        >
          <TableBody>
            {CombinedArray?.map((row, index) => (
              <TableRow
                sx={{
                  "&:hover": {
                    background: theme.palette.grey[200],
                    cursor: "pointer",
                  },

                  backgroundColor: "transparent",
                }}
              >
                <Tablecell
                  align="left"
                  sx={{
                    fontWeight: "900",
                    fontSize: "12px",
                    paddingLeft: "5px",
                    color: theme.palette.text.primary,
                    borderRight: "none",
                    borderLeft: "none",
                    borderTop: "none",
                    borderBottom:
                      row.name == "Short"
                        ? `1px solid ${theme.palette.divider}`
                        : "none",
                  }}
                >
                  {row?.name}
                </Tablecell>

                <Tablecell
                  align="right"
                  sx={{
                    fontWeight: "500",
                    fontSize: "12px",
                    paddingLeft: "5px",
                    color: theme.palette.text.primary,
                    borderRight: "none",
                    borderLeft: "none",
                    borderTop: "none",
                    borderBottom:
                      row.name == "Short"
                        ? `1px solid ${theme.palette.divider}`
                        : "none",
                  }}
                >
                  {index === 0 ? row.value : `${row.value}%`}
                </Tablecell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
export default SummarySectionTwo;
